import { Tooltip } from "react-bootstrap";

const tooltipRegistry = {
    composeButton: (
        <Tooltip id="tooltip-compose">
            Start a new message using the current patient context
        </Tooltip>
    ),
    replyButton: (
        <Tooltip id="tooltip-reply">
            Reply to the selected message in the thread
        </Tooltip>
    ),
    loadMoreButton: (
        <Tooltip id="tooltip-loadMore">
            Load more messages
        </Tooltip>
    ),
    refreshButton: (
        <Tooltip id="tooltip-refresh">
            Refresh your conversations
        </Tooltip>
    ),
    encounterCard: (
        <Tooltip id="tooltip-encounter">
            Click to view encounter details
        </Tooltip>
    ),
     providerCard: (
        <Tooltip id="tooltip-provider">
            Click to view provider details
        </Tooltip>
    ),

     patientCard: (
        <Tooltip id="tooltip-patient">
            Click to view patient details
        </Tooltip>
    ),
    patientSearch: (
        <Tooltip id="tooltip-patient-search">
            Search for patients by name
        </Tooltip>
    ),
    circleOfCare: (
        <Tooltip id="tooltip-coc">
            Select to find the providers in the patient's circle of care
        </Tooltip>
    ),
    // Add more tooltips here as needed
};

export default tooltipRegistry;